import { useEffect, useMemo } from 'react'
import { useAtom } from 'jotai'

import { ScrollableFeatureList, ScrollableLatelyAccessList } from '@!/Store/Common/components'
import { PointBackBanner, CampaignHeaderBanner } from '@!/components/Banner'
import { ContentList, HeaderInfo } from '@!/Store/FeatureList/components'
import { parsePermitTime } from '@!/Store/Common/util/time'

import { Box, Divider, Stack } from '@chakra-ui/react'
import { breadcrumbAtom } from '@!/atoms/breadcrumbAtom'
import { SearchForm } from '@!/Store/Common/containers'

export const StoreFeatureList = ({ items, currentTime }) => {
  const [, setBreadcrumb] = useAtom(breadcrumbAtom)

  useEffect(() => {
    setBreadcrumb([{ name: 'マンガBANGブックス', ref: '/' }, { name: items.title }])
  }, [items.title])

  const time = Date.parse(currentTime)
  const featureContents = useMemo(() => {
    return items.contents.filter((content) => {
      const permitStart = parsePermitTime(content.permit_start)
      const permitEnd = parsePermitTime(content.permit_end, true)

      return permitStart < time && time < permitEnd
    })
  }, [items.contents, time])
  const otherFeatures = items.other_features || []
  const campaign = items.campaign_info

  return (
    <>
      {campaign ? <CampaignHeaderBanner campaign={campaign} /> : <PointBackBanner />}
      <SearchForm />
      <Box px="1rem">
        <HeaderInfo title={items.title} />
        <Divider />
        <ContentList contents={featureContents} />
        <Divider />
      </Box>
      <Stack py={6} spacing={4}>
        <ScrollableLatelyAccessList />
        {otherFeatures.map((feature) => {
          return <ScrollableFeatureList key={feature.pathname} title={feature.title} pathname={feature.pathname} contents={feature.contents} />
        })}
      </Stack>
    </>
  )
}

export default StoreFeatureList
